// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3S6Q3","actionsCol":"EnrolledClinics_actionsCol__7J56u"};